import styled from "styled-components"

const Textarea = styled.textarea`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.grey1};
  border-radius: 3px;
  min-height: 100px;
  padding: 10px;
`

export default Textarea
